import { assertNever } from '@kofno/piper';
import { TPlainTextKey } from '../../../Translations';

// The buckets AdminStudio shows licensing in. They collapse the platform's
// offering types, but not group coaching: it is sold as its own product, is
// granted by its own license types, and the platform labels it separately in
// ProgramFamily.public_program_type.
export type ProgramCategory =
  | 'professor-led'
  | 'on-demand'
  | 'leadership-coaching'
  | 'group-coaching';

export const ALL_PROGRAM_CATEGORIES: ProgramCategory[] = [
  'professor-led',
  'on-demand',
  'leadership-coaching',
  'group-coaching',
];

// offering_type arrives from the server as an open string rather than a union,
// so this falls back rather than asserting never: a new offering type should
// land somewhere sensible instead of throwing in front of an admin.
export const programCategoryFor = (offeringType: string): ProgramCategory => {
  switch (offeringType) {
    case 'epc':
      return 'professor-led';
    case 'coaching':
      return 'leadership-coaching';
    case 'group-coaching':
      return 'group-coaching';
    case 'aep':
    case 'msuite':
    case 'program-sequence':
    default:
      return 'on-demand';
  }
};

export const programCategoryLabel = (category: ProgramCategory): TPlainTextKey => {
  switch (category) {
    case 'professor-led':
      return 'Professor-Led';
    case 'on-demand':
      return 'On-Demand';
    case 'leadership-coaching':
      return 'Leadership Coaching';
    case 'group-coaching':
      return 'Group Coaching';
    default:
      return assertNever(category);
  }
};
